import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import { pdfSharedStyles } from '../pdfSharedStyles';
import { getProjectTypeDisplayName, getLogoPath } from './PdfHelpers';
import { PdfHeaderProps } from './types/PdfCommonTypes';

/**
 * Unified PDF Header Component
 * Eliminates duplication across 10+ PDF files and provides configurable header display
 */
export const PdfHeader: React.FC<PdfHeaderProps> = ({ projectType, t, customTitle, showGeogridSubtitle = true, customProjectType, customSubtitle }) => (
    <View style={pdfSharedStyles.projectInfoHeader} fixed>
        <View style={pdfSharedStyles.projectInfoHeaderTop}>
            <View style={pdfSharedStyles.projectInfoLeftSection}>
                <Image style={pdfSharedStyles.projectInfoLogo} src={getLogoPath()} />
                <View>
                    <Text style={pdfSharedStyles.projectInfoSubtitle2}>{customTitle || 'MACREAD - design Technical Report'}</Text>
                    <Text style={pdfSharedStyles.projectInfoProjectType}>{customProjectType || getProjectTypeDisplayName(projectType, t)}</Text>
                    {customSubtitle ? (
                        <Text style={pdfSharedStyles.projectInfoSubtitle}>{customSubtitle}</Text>
                    ) : (
                        showGeogridSubtitle && <Text style={pdfSharedStyles.projectInfoSubtitle}>{t('designing_geogrid') || 'Designing geogrid'}</Text>
                    )}
                </View>
            </View>
            <View style={pdfSharedStyles.projectInfoRightSection}>
                <Text style={[pdfSharedStyles.projectInfoSubtitle, { color: 'black', fontSize: 8 }]}>edesign.maccaferri.com</Text>
                <Text style={pdfSharedStyles.pageNumberHeader} render={({ pageNumber, totalPages }) => `Page ${pageNumber} / ${totalPages}`} />
            </View>
        </View>
        <View style={pdfSharedStyles.spacer1} />
    </View>
);
